import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type ChoicesSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_CHOICES_SORT_OPTION: ChoicesSortOption = "newest";

const OPTIONS: SortOption<ChoicesSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function choicesSortOptionLabel(option: ChoicesSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function choicesSortOptionToParams(option: ChoicesSortOption): {
  sortBy: "createdAt" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "createdAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "createdAt", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortChoicesPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: ChoicesSortOption;
  setSortOption: (option: ChoicesSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Surveys"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
